import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import {
	fetchConversionRates,
	mergeRatesIntoPharmacyPOS,
	persistPharmacyPOS,
} from "../utils/conversionRates";

const pharmacyContext = createContext();

export const PharmacyProvider = (props) => {
	const [pharmacyPOS, setPharmacyPOS] = useState(() => {
		const saved = localStorage.getItem("currentPharmacyPOS");
		return saved ? JSON.parse(saved) : null;
	});

	const pharmacyPOSRef = useRef(pharmacyPOS);

	useEffect(() => {
		pharmacyPOSRef.current = pharmacyPOS;
	}, [pharmacyPOS]);

	const refreshConversionRates = useCallback(async () => {
		const result = await fetchConversionRates(pharmacyPOSRef.current);

		if (result.success) {
			const updated = mergeRatesIntoPharmacyPOS(
				pharmacyPOSRef.current,
				result.rates,
				result.baseCurrency
			);
			persistPharmacyPOS(updated);
			pharmacyPOSRef.current = updated;
			setPharmacyPOS(updated);
		}

		return result;
	}, []);

	return (
		<pharmacyContext.Provider
			value={{ ...props, pharmacyPOS, setPharmacyPOS, refreshConversionRates }}
		>
			{props.children}
		</pharmacyContext.Provider>
	);
};

export const usePharmacy = () => useContext(pharmacyContext);
